import React from 'react'
import PosterGrid from '../PosterGrid'
import WeisherHero from '../Weischer/WeisherHero'
import AdvertisementsHero from '../Advertisements/AdvertisementsHero'


const OverviewHero = ({overviewHeroItems, overviewHeroAdvertisementItems, features, movies}) => (
    overviewHeroItems.length > 0 ? (
        <WeisherHero
            overviewHeroItems={overviewHeroItems}
            features={features}
        />
    ) :
    
    overviewHeroAdvertisementItems.length > 0 ? (
        <AdvertisementsHero
            items={overviewHeroAdvertisementItems}
            features={features}
        />

    ) : 
    
    movies && movies.hasOwnProperty('items') ? (
        <PosterGrid 
            movies={movies.items}
            moviesOrder={movies.order}
        />
    ) : ('')
)

export default OverviewHero